// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2l9Wr","header":"PatientQuestionnaire_header__1txJE","info":"PatientQuestionnaire_info__3Oy9z"};